import { render } from "./SettingsScreen.vue?vue&type=template&id=444a99b7&scoped=true"
import script from "./SettingsScreen.vue?vue&type=script&lang=js"
export * from "./SettingsScreen.vue?vue&type=script&lang=js"

import "./SettingsScreen.vue?vue&type=style&index=0&id=444a99b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-444a99b7"

export default script